import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { authFB } from '../../../helpers/Firebase';
import { servicePath, storagePath } from '../../../constants/defaultValues';
import { storage } from '../../../helpers/Firebase';
import { NotificationManager } from '../../../components/common/react-notifications';
import {
    IDX_RPT_QUALITY_REPORT,
    IDX_RPT_QUALITY_SUPPLIER,
    IDX_RPT_QUALITY_PRODUCT,
    IDX_RPT_QUALITY_MTX_QA_MED,
    IDX_RPT_QUALITY_SUPPLIER_MMQ,
    IDX_RPT_QUALITY_PRODUCT_MMQ,
    IDX_RPT_QUALITY_MTX_QA_MMQ
} from "../../actions";

import {
    IdxRptQualityReportSuccess,
    IdxRptQualityReportError,
    IdxRptQualitySupplierSuccess,
    IdxRptQualitySupplierError,
    IdxRptQualityProductSuccess,
    IdxRptQualityProductError,
    IdxRptQualityMtxQAMedSuccess,
    IdxRptQualityMtxQAMedError,
    IdxRptQualitySupplierMmqSuccess,
    IdxRptQualitySupplierMmqError,
    IdxRptQualityProductMmqSuccess,
    IdxRptQualityProductMmqError,
    IdxRptQualityMtxQAMmqSuccess,
    IdxRptQualityMtxQAMmqError
} from '../../actions';

export function* watchIdxRptQualityReport() {
    yield takeEvery(IDX_RPT_QUALITY_REPORT, onIdxRptQualityReport);
}

export function* watchIdxRptQualitySupplier() {
    yield takeEvery(IDX_RPT_QUALITY_SUPPLIER, onIdxRptQualitySupplier);
}

export function* watchIdxRptQualityProduct() {
    yield takeEvery(IDX_RPT_QUALITY_PRODUCT, onIdxRptQualityProduct);
}

export function* watchIdxRptQualityMtxQAMed() {
    yield takeEvery(IDX_RPT_QUALITY_MTX_QA_MED, onIdxRptQualityMtxQAMed);
}

export function* watchIdxRptQualitySupplierMmq() {
    yield takeEvery(IDX_RPT_QUALITY_SUPPLIER_MMQ, onIdxRptQualitySupplierMmq);
}

export function* watchIdxRptQualityProductMmq() {
    yield takeEvery(IDX_RPT_QUALITY_PRODUCT_MMQ, onIdxRptQualityProductMmq);
}

export function* watchIdxRptQualityMtxQAMmq() {
    yield takeEvery(IDX_RPT_QUALITY_MTX_QA_MMQ, onIdxRptQualityMtxQAMmq);
}

function getToken(auth) {
    return new Promise((resolve, reject) => {
        const unsubscribe = auth.onAuthStateChanged(user => {
            user.getIdToken().then((token) => {
                unsubscribe();
                resolve(token);
            });
        }, reject);
    });
}

const onIdxRptQualityReportAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxquality/listreport', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptQualitySupplierAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxquality/supplier', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptQualityProductAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxquality/product', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptQualityMtxQAMedAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxquality/matrixmed', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};


const onIdxRptQualitySupplierMmqAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxquality/suppliermmq', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptQualityProductMmqAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxquality/productmmq', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};

const onIdxRptQualityMtxQAMmqAsync = async (payload) => {
    let token = await getToken(authFB);
    const response = await fetch(servicePath + 'idxquality/matrixmmq', {
        method: 'POST', mode: 'cors', cache: 'no-cache',
        headers: { 'Content-Type': 'application/json', 'token': token },
        body: JSON.stringify(payload)
    })
        .then(response => response.json())
        .then(data => { return data; })
        .catch(err => console.log(err));
    return { "data": response };
};


function* onIdxRptQualityReport(data) {
    try {
        const response = yield call(onIdxRptQualityReportAsync, data.payload);
        yield put(IdxRptQualityReportSuccess(response.data));
    } catch (error) {
        yield put(IdxRptQualityReportError(error));
    }
}

function* onIdxRptQualitySupplier(data) {
    try {
        const response = yield call(onIdxRptQualitySupplierAsync, data.payload);
        yield put(IdxRptQualitySupplierSuccess(response.data));
    } catch (error) {
        yield put(IdxRptQualitySupplierError(error));
    }
}

function* onIdxRptQualityProduct(data) {
    try {
        const response = yield call(onIdxRptQualityProductAsync, data.payload);
        yield put(IdxRptQualityProductSuccess(response.data));
    } catch (error) {
        yield put(IdxRptQualityProductError(error));
    }
}

function* onIdxRptQualityMtxQAMed(data) {
    try {
        const response = yield call(onIdxRptQualityMtxQAMedAsync, data.payload);
        yield put(IdxRptQualityMtxQAMedSuccess(response.data));
    } catch (error) {
        yield put(IdxRptQualityMtxQAMedError(error));
    }
}

function* onIdxRptQualitySupplierMmq(data) {
    try {
        const response = yield call(onIdxRptQualitySupplierMmqAsync, data.payload);
        yield put(IdxRptQualitySupplierMmqSuccess(response.data));
    } catch (error) {
        yield put(IdxRptQualitySupplierMmqError(error));
    }
}

function* onIdxRptQualityProductMmq(data) {
    try {
        const response = yield call(onIdxRptQualityProductMmqAsync, data.payload);
        yield put(IdxRptQualityProductMmqSuccess(response.data));
    } catch (error) {
        yield put(IdxRptQualityProductMmqError(error));
    }
}

function* onIdxRptQualityMtxQAMmq(data) {
    try {
        const response = yield call(onIdxRptQualityMtxQAMmqAsync, data.payload);
        yield put(IdxRptQualityMtxQAMmqSuccess(response.data));
    } catch (error) {
        yield put(IdxRptQualityMtxQAMmqError(error));
    }
}

export default function* rootSaga() {
    yield all([
        fork(watchIdxRptQualityReport),
        fork(watchIdxRptQualitySupplier),
        fork(watchIdxRptQualityProduct),
        fork(watchIdxRptQualityMtxQAMed),
        fork(watchIdxRptQualitySupplierMmq),
        fork(watchIdxRptQualityProductMmq),
        fork(watchIdxRptQualityMtxQAMmq)
    ]);
}
